import React, { Fragment } from "react";
import { ShimmerButton, ShimmerCategoryItem, ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";
var AssignmentTemplatesSkeletalLoader = function AssignmentTemplatesSkeletalLoader(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React.createElement(Fragment, null, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card mb-4",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-header d-md-flex justify-content-md-between align-items-center px-md-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mb-2 w-50"
    }, /*#__PURE__*/React.createElement(ShimmerTitle, {
      line: 1,
      variant: "primary"
    })), /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center flex-grow-1 justify-content-end"
    }, /*#__PURE__*/React.createElement(ShimmerCircularImage, {
      size: 50
    }), /*#__PURE__*/React.createElement("div", {
      className: "w-25 ms-2"
    }, /*#__PURE__*/React.createElement(ShimmerTitle, {
      line: 1,
      variant: "primary"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "card-body px-md-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-lg-7 col-xl-8 mb-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-start w-100"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ms-2 grey-text w-75"
    }, /*#__PURE__*/React.createElement(ShimmerCategoryItem, {
      title: true
    })))), /*#__PURE__*/React.createElement("div", {
      className: "col-lg-5 col-xl-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-sm-center text-lg-end d-flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ShimmerButton, {
      size: "md"
    })), /*#__PURE__*/React.createElement("div", {
      className: "me-2"
    }, /*#__PURE__*/React.createElement(ShimmerButton, {
      size: "md"
    })))))));
  }));
};
AssignmentTemplatesSkeletalLoader.defaultProps = {
  items: [1, 2, 3, 4, 5, 6]
};
export default AssignmentTemplatesSkeletalLoader;